import {
  commitmentItemsFulfilled,
  commitmentItemsPending,
  commitmentItemsRejected,
  commitmentStatusesFulfilled,
  commitmentStatusesPending,
  commitmentStatusesRejected,
} from 'legacy/lut/features/partner360/commitment/commitmentDataLifecycle'
import {
  partnerDataFulfilled,
  partnerDataPending,
  partnerDataRejected,
} from 'legacy/lut/features/partner360/configuration/partnerDataLifecycle'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { getUrlParam } from 'core-components/helpers/url'
import { PID_URL } from 'partner360/configs'

import { requestFinancialCockpitData } from '../model/thunks'

const hasPid = () => Boolean(getUrlParam(PID_URL))

/* A reload under an open plan section, or for another year with the page kept on screen, leaves
   the sections' data as it is, so the sections stay while the cockpit loads; the fulfilled action
   below replaces the data. */
listenerMiddleware.startListening({
  predicate: (action): action is ReturnType<typeof requestFinancialCockpitData.pending> =>
    requestFinancialCockpitData.pending.match(action) &&
    !action.meta.arg.keepSectionsLoaded &&
    !action.meta.arg.keepOnScreen &&
    hasPid(),
  effect: (_, { dispatch }) => {
    dispatch(commitmentItemsPending())
    dispatch(commitmentStatusesPending())
    dispatch(partnerDataPending())
  },
})

listenerMiddleware.startListening({
  predicate: (action): action is ReturnType<typeof requestFinancialCockpitData.rejected> =>
    requestFinancialCockpitData.rejected.match(action) && hasPid(),
  effect: (action, { dispatch }) => {
    dispatch(commitmentItemsRejected(action.error.message))
    dispatch(commitmentStatusesRejected(action.error.message))
    dispatch(partnerDataRejected(action.error.message))
  },
})

listenerMiddleware.startListening({
  predicate: (action): action is ReturnType<typeof requestFinancialCockpitData.fulfilled> =>
    requestFinancialCockpitData.fulfilled.match(action) && hasPid(),
  effect: (action, { dispatch }) => {
    const partnerData = action.payload.PartnerData[0]

    dispatch(
      commitmentItemsFulfilled(
        (action.payload.CommitmentData ?? []).flatMap((it) => it.CommitmentData)
      )
    )
    dispatch(
      commitmentStatusesFulfilled(
        (action.payload.CommitmentStatus ?? []).flatMap((it) => it.CommitmentStatus)
      )
    )
    if (partnerData) {
      dispatch(
        partnerDataFulfilled(partnerData, { keepSelections: action.meta.arg.keepSectionsLoaded })
      )
    } else {
      dispatch(partnerDataRejected('Partner data is missing in cockpit response'))
    }
  },
})
